const config = {
    env: 'ngi-test',
    cognito: {
        userPoolId: 'eu-west-1_uKO6oVcQ1',
        domain: 'https://ngi-auth-ngi-test.auth.eu-west-1.amazoncognito.com',
        landingDomain: 'https://ngi-test.promo.mgas.ke',
        state: 'web.b2cdashboard',
        clientId: '3chtlmff72mgsj2pjupsu80161',
        redirectUrl: 'https://d2xfarreuj3r0d.cloudfront.net',
        region: 'eu-west-1',
        clientSecret: '1uchbssi4knf5ooai0uum3n63a9sfkdqj1lusipar41novpv37ds'
    }
}
export default config
